// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";


// Stateless components

export function SimulateSection(props) {

    var callback_functions = props['callbacks'];
    var simulate_fn = callback_functions['simulate'];
    var clear_fn = callback_functions['clear'];
    var is_loading = props['is_loading'];
    var error_response = props['data_request_error'];

    //
    // Render
    //

    function loadingIcon(context) {
        let configuration = context['configuration'];
        let loader = <img className='simulate-user__loading-img' src={configuration['images']['loader.gif']['url']} alt="Loading..." />;

        if (is_loading) {
            return loader;
        }
        return null;
    }
        
    function SimulationForm() {
        var simulate_label = 'Enter sNumber to simulate';
        var submit_label = 'Simulate';

        return (
            <div className="simulate-user">
                <RequestDataDisplay/>
                <div className="simulate-user__text">
                    <label htmlFor="simulate__snumber" className="simulate__label">{simulate_label}</label>
                    <form className="simulate__group" onSubmit={simulate_fn}>
                        <input type="text" id="simulate__snumber" name="snumber" />
                        <button type="submit" className="btn btn-primary panel-tools__button" onClick={simulate_fn} disabled={is_loading}>{submit_label}</button>
                    </form>
                </div>
            </div>
        );
    }

    function RequestDataDisplay() {

        let error_response_message = null;

        if (error_response) {
            error_response_message = JSON.parse(error_response['response'])['error_description'];
        }

        if (is_loading) {
            return (
                <PortalContext.Consumer>
                    {loadingIcon}
                </PortalContext.Consumer>
            )
        } else if (error_response_message) {
            return (
                <div>
                    { error_response_message }
                </div>
            )
        }
        return null;
    }

    function renderClearForm(context) {
        var user_profile = context['user_personalisation'];
        var is_simulated = user_profile['isImpersonated'];

        if(is_simulated) {
            var snumber = user_profile['sNumber'];
            var simulate_label = 'Currently simulating: ';
            var button_label = 'Clear';

            return (
                <div className="simulation-panel__dialogue__sim-user__current">
                    <span className="simulate__label">{simulate_label}</span>
                    <div className="simulate__group">
                        <span className="simulate__value">{snumber}</span>
                        <button className="btn btn-primary panel-tools__button" onClick={clear_fn} disabled={is_loading}>{button_label}</button>
                    </div>
                </div>
            );
        }

        return null;
    }

    return (
        <div className="simulation-section">
            <SimulationForm />
            <PortalContext.Consumer>
                {renderClearForm}
            </PortalContext.Consumer>
        </div>    
    );
};
